import { Component, OnInit } from '@angular/core';
import { ContentService, NewsItem } from '../../../cms/content.service';

@Component({
    selector: 'app-blog',
    templateUrl: './blog.component.html',
    styleUrls: ['./blog.component.scss'],
    standalone: false
})
export class BlogComponent implements OnInit {
    newsItems: Array<NewsItem & { coverUrl: string | null }> = [];

    constructor(private contentService: ContentService) {}

    ngOnInit(): void {
        this.contentService.getNews().subscribe(response => {
            this.newsItems = response.data.map(news => ({
                ...news,
                coverUrl: this.contentService.assetUrl(news.cover)
            }));
        });
    }

    formatDate(value: string | null | undefined): string {
        if (!value) return '';
        const normalized = value.length <= 10 ? `${value}T00:00:00Z` : value;
        const date = new Date(normalized);
        if (Number.isNaN(date.getTime())) return '';
        return new Intl.DateTimeFormat('es-CO', {
            day: 'numeric',
            month: 'long',
            year: 'numeric',
            timeZone: 'UTC'
        }).format(date);
    }
}
